module.exports = __webpack_public_path__ + "img/cpany22.a7a39733.png";